export * from './stormpath.module';

// all components that will be codegen'd need to be exported for AOT to work
export * from './authport/index';
export * from './email-verification/index';
export * from './forgot-password/index';
export * from './login/index';
export * from './register/index';
export * from './resend-email-verification/index';
export * from './reset-password/index';
export * from './shared/index';
export * from './stormpath/index';



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader?keepUrl=true!./node_modules/tslint-loader!./src/index.ts